var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("li", { staticClass: "case-card" }, [
    _c(
      "a",
      { staticClass: "case-card__inner", attrs: { href: _vm.caseItem.Url } },
      [
        _vm.caseItem.HasImage
          ? _c("ResponsiveImage", {
              attrs: {
                wrapperClass: "case-card__image",
                imageModel: _vm.caseItem.ImageForVue,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _c("p", { staticClass: "case-card__tag" }, [
          _vm._v(
            "\n            " + _vm._s(_vm.caseItem.Solution) + "\n        "
          ),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "case-card__name" }, [
          _vm._v("\n            " + _vm._s(_vm.caseItem.Name) + "\n        "),
        ]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }